import { useHover, useWindowSize } from '@uidotdev/usehooks'
import SvgArrow from '../../shared/components/arrowLinks/svgArrow'

import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

const ContentComponent = ({ item }) => {
  const [ref, hovering] = useHover()
  const { width } = useWindowSize()
  const DESKTOP_MIN_WIDTH = 1024 // 1024px
  return (
    <div className="card-body" ref={ref}>
      <div className={`image-container ${item?.use_container ? 'boxed' : ''}`}>
        <img src={item?.image?.url} alt={item?.image?.alt} />
      </div>
      <div className="card-step">
        <span>{item?.tag_title}</span>
        <div className="w-[25px]">
          {(hovering || width < DESKTOP_MIN_WIDTH) && (
            <motion.a
              initial={{
                opacity: 0,
                transition: {
                  type: 'spring',
                  duration: 2.5,
                },
              }}
              viewport={{
                amount: 0.1,
                once: false,
              }}
              whileInView={{
                opacity: 1,
                transition: {
                  type: 'spring',
                  duration: 2.5,
                },
              }}
              href={item?.link_reference?.url ?? '/#'}
              target={item?.link_reference?.target ?? '_self'}
            >
              <SvgArrow className="svgArrow rotate-190" />
            </motion.a>
          )}
        </div>
      </div>
      <div className="card-content">
        <h3>{item?.title}</h3>
        <p>{item?.description}</p>
      </div>
    </div>
  )
}

ContentComponent.propTypes = {
  item: PropTypes.object.isRequired,
}

export default ContentComponent
